
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-make-money-online-videos",
      function () {
        return require("private-next-pages/how-to-make-money-online-videos/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-make-money-online-videos"])
      });
    }
  